import { axiosObject } from "../config";

export default function resetPassword(form: any) {
  let payload = {
    token: form.value.token,
    user_uuid: form.value.user_uuid,
    password: form.value.password,
    return_with_token: true,
  };

  return new Promise((resolve, reject) => {
    let uri = "access/reset-password-with-link";

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (errors.response.data.message === "Invalid Token") {
            form.setErrors({ otp: ["Invalid otp"] });
          }
          reject(errors.response.data.errors);
        }
        reject(errors);
      });
  });
}
